import { WidgetVersionController } from 'widgets/WidgetVersionManager/WidgetVersionManager.types';

// the latest version of the widget
export const VERSION = 2;

class UpgradeV2 {
  version = 2;
  upgrade(widget: any) {
    if (widget.numberFormat) {
      const { decimalPrecision, ...otherNumberFormat } = widget.numberFormat;
      widget.numberFormat = {
        ...otherNumberFormat,
        separator: 'None',
        precision: 'Auto',
      };
    }
  }
}

// Add VersionControllers here that implement the WidgetVersionController interface
export const halfPieChartWidgetVersionControllers: WidgetVersionController[] = [new UpgradeV2()];
